import React, { useState } from "react";

import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";

import { fetchFeedbackPost } from "../../../services/api-raindrop.js";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";

const CirrusFeedback = ({ organisation, currentOrganisationUser }) => {
  const [inputText, setInputText] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const onSubmitFeedback = () => {
    setIsLoading(true);

    fetchFeedbackPost({
      text: inputText,
      application: "cirrus",
    })
      .then(() => {
        setHasSubmitted(true);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (hasSubmitted) {
    return (
      <div className="flex flex-col h-full items-center w-full justify-center gap-12">
        <i className="fas fa-check-circle text-5xl text-color-raindrop-primary"></i>
        <h1 className="text-xl font-bold">Thank you for your feedback</h1>
        <p className="text-color-text-secondary">
          We appreciate your feedback and will take it into consideration.
        </p>
        <RaindropButton
          title={"Submit more feedback"}
          isPrimary={false}
          onClick={() => setHasSubmitted(false)}
        />
      </div>
    );
  }

  return (
    <div className={`flex flex-col w-full h-full gap-6 max-w-md`}>
      <h1 className="font-bold text-4xl">Feedback</h1>

      <p className="text-color-text-secondary">
        Your feedback is extremely valuable to us. We want to hear the good, the
        bad and your suggestions on how we can improve.
      </p>

      <form className="flex flex-col gap-4 items-end w-full">
        <RaindropInputTextArea
          // placeholder={"Please provide your feedback here..."}
          onChange={(e) => setInputText(e.target.value)}
          value={inputText}
          example="I would like to see more of this feature"
        />
        <RaindropButton
          icon="fa-comment"
          title={"Submit Feedback"}
          isPrimary={false}
          onClick={onSubmitFeedback}
          isLoading={isLoading}
        />
      </form>
    </div>
  );
};

export default CirrusFeedback;
